import React, { Component }     from 'react';
import { connect }              from 'react-redux';
import { GetRegistroPostTurma } from '../../../../actions/turmaAction';
import { SetError }             from '../../../../actions/notificacaoAction';
import TripulacaoTimeLine       from './tripulacao_timeLine';
import { GetActionBg }          from '../../../../actions/scopoAction';
import TopoComunicacao          from '../topo_comunicacao';
import '../../../../css/aluno/comunicacao/communication.css';
import '../../../../css/aluno/comunicacao/communication_author.css';
import '../../../../css/aluno/comunicacao/communication_input.css';
import '../../../../css/aluno/comunicacao/communication_messages.css';
import '../../../../css/aluno/comunicacao/communication_comments.css';
import '../../../../css/aluno/box.css';
import bg_tripulacao from "../../../../img/bg/bg_tripulacao.png";

class tripulacao extends Component {

    constructor(props){
        super(props);
        this.state = { load : false, logAluno  : false, routerPage: false }
    }

    componentWillMount() {
        this.CarregarPostsTripulacao();
        this.props.GetActionBg(bg_tripulacao);
    }

    CarregarPostsTripulacao(){
        this.setState({ load : false});
        this.props.GetRegistroPostTurma(this.props.session.id, this.props.session.turma).then((response) => {
            if(!response.payload.data){
                alert("O seu usuário, não foi encontrado em nenhum Turma. Entre em contato com o seu professor, para maiores informações.");
                this.setState({routerPage:true})
            }else{
                this.setState({ load : true,logAluno:true });  
            }
        }).catch((error) => {
            this.props.SetError(500);
        });
    }

    render() {
        return (
            <div className="hud-middle-center active">
               <TopoComunicacao nome="Tripulação"/>
       
                <main className="hud-middle-center-content">
                  <TripulacaoTimeLine/>                                   
                </main>
            </div>     
        );
    }
}
function mapStateToProps(state) {

    return { 
            session : state.auth.session,
            menu    : state.configReducer.menu,
            all_posts: state.turmaReducer.all_posts
           }
}

export default connect(mapStateToProps, { GetRegistroPostTurma, SetError,GetActionBg })(tripulacao);




// WEBPACK FOOTER //
// ./src/components/aluno/comunicacao/tripulacao/tripulacao.js